import * as React from 'react';
import DetailsCard from '../common/DetailsCard';
import BarChart from '../../BarChart';
import { formatCurrency } from '../../CurrencyUtils';
import dayjs from 'dayjs';
import { PAY_HISTORY_DEFAULT_DATA_POINTS } from '../PayHistorySummaryCard';
import './style/index.scss';
export class PayHistoryBarChartCard extends React.PureComponent {
    render() {
        return (React.createElement(DetailsCard, { className: "pay-history-bar-chart-card" },
            React.createElement("div", { className: "pay-history-bar-chart-card__viz" },
                React.createElement(BarChart, { bars: this._getBarsForChart(), minBarHeight: 1, minBars: 3, showDeltaTooltip: true, firstBarHeightPercent: this.props.firstBarHeightPercent }))));
    }
    _getBarsForChart() {
        const { historyDataPoints, baseSalary, payEffectiveDate, maxDataPoints } = this.props;
        if (!historyDataPoints || historyDataPoints.length === 0) {
            return [this._getBar(baseSalary, payEffectiveDate)];
        }
        let tempDataPoints = historyDataPoints;
        tempDataPoints.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
        tempDataPoints = tempDataPoints.slice(-(maxDataPoints || PAY_HISTORY_DEFAULT_DATA_POINTS));
        return tempDataPoints.map(d => this._getBar(d.baseSalary, d.createdAt));
    }
    _getBar(val, date) {
        const { currency, annualOrHourly } = this.props;
        return {
            value: val,
            axisLabel: dayjs(date).format('MM/YY'),
            label: annualOrHourly && annualOrHourly.toLowerCase() === 'hourly' ? formatCurrency(val, currency, { abbreviate: true, fractionalDigits: 2, showDecimalZeros: true }) : formatCurrency(val, currency, { abbreviate: true, fractionalDigits: 1, showDecimalZeros: false })
        };
    }
}
export default PayHistoryBarChartCard;
